import api from '@pray/shared/utils/api';

export type GetImpressionAnalyticsParams = {
  artistId: string;
  dateRangeStart?: string | null;
  dateRangeEnd?: string | null;
  placement?: string | null;
  platform?: string | null;
};

export const getImpressionAnalytics = async ({
  artistId,
  dateRangeStart = null,
  dateRangeEnd = null,
  placement = null,
  platform = null,
}: GetImpressionAnalyticsParams) => {
  const params: Record<string, string> = {};

  if (dateRangeStart) params.date_range_start = dateRangeStart;
  if (dateRangeEnd) params.date_range_end = dateRangeEnd;
  if (placement) params.placement = placement;
  if (platform) params.platform = platform;

  const url = `/web/studio/artists/${artistId}/marketing-impressions/analytics`;
  const response = await api.executeGetRequest(url, params);

  return (response.data as any)?.data;
};
